import { CalendarDate } from '@internationalized/date';
import {
  CreateBillInput,
  BillType,
  BillComplianceRule,
  PaymentMethod,
  PaymentTerm,
  BillLineItemInput,
  MoneyInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type BillCreateParams = {
  type: BillType;
  documentNumber?: string;
  documentDate: CalendarDate;
  eligibleAt?: CalendarDate | null;
  accountId?: string | null;
  facilityId: string;
  paymentTerm: PaymentTerm;
  preferredPaymentMethod: PaymentMethod;
  compliance: BillComplianceRule[];
  notes?: string | null;
  scaleTicketId?: string | null;
  amount: MoneyInput;
  lineItems?: BillLineItemInput[];
};

export const billCreateAtom = createMutationAtomFactory(
  'finance.billCreate',
  (params: BillCreateParams) => {
    const input: CreateBillInput = {
      type: params.type,
      documentDate: params.documentDate.toString(),
      facilityID: params.facilityId,
      paymentTerm: params.paymentTerm,
      preferredPaymentMethod: params.preferredPaymentMethod,
      compliance: params.compliance,
      amount: params.amount,
      accountID: params.accountId ?? '',
    };

    if (params.documentNumber) {
      input.documentNumber = params.documentNumber;
    }
    if (params.eligibleAt) {
      input.eligibleAt = params.eligibleAt.toString();
    }
    if (params.notes) {
      input.notes = params.notes;
    }
    if (params.scaleTicketId) {
      input.scaleTicketID = params.scaleTicketId;
    }
    if (params.lineItems) {
      input.lineItems = params.lineItems;
    }

    return {
      financeBillCreate: {
        __args: {
          input,
        },
        id: true,
        documentNumber: true,
        status: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
